export enum VideoElementId {
  localPrimary = 'localPrimary',
  localPrimaryPreview = 'localPrimaryPreview',
  localSecondary = 'localSecondary',
  remoteSecondary = 'remoteSecondary',
  remotePrimary = 'remotePrimary'
}



// WEBPACK FOOTER //
// ./src/constants/ElementIds.ts